// Added by Sejune Oh on 2019-08-22
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Root store
import RootStore from '../../index'

// Base
import ConfigBase from './ConfigBase'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default class PackageConfigStore extends ConfigBase {
    constructor(root: RootStore) {
        super(root, 'package')
    }

    GetPackageConfigByKey = (key: string) => {
        const config = this.getConfig(key)
        if (!config) return null

        const { type, value } = config
        if (type === 'bool') return value === 'true'

        return value
    }

    getPackageConfigByVariable = (key: string) => {
        const config = this.getConfig(key)
        if (!config) return null

        const { type, value } = config
        if (type === 'bool') return value === 'true'

        return value
    }

    setPackageConfigOption = this.setConfigOption

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    checkDashboardEnable = () => {
        if (!this.root!.userAuth!.isSignedUp) return false

        const dashboardEnable = this.GetPackageConfigByKey('Dashboard.Enable')
        if (dashboardEnable === null) return false
        return dashboardEnable as boolean
    }

    checkDashboardIsLanding = () => {
        if (!this.root!.userAuth!.isSignedUp) return false

        const useDashboardAsLanding = this.GetPackageConfigByKey('Dashboard.UseDashboardAsLanding')
        if (useDashboardAsLanding === null) return false
        return useDashboardAsLanding as boolean
    }

    checkEnableScreenShareDisconnectError = () => {
      if (!this.root!.userAuth!.isSignedUp) return false

      const enableScreenShareDisconnectError = this.GetPackageConfigByKey('Test.ShowScreenShareDisconnectionErrorButton')
      if (enableScreenShareDisconnectError === null) return false
      return enableScreenShareDisconnectError as boolean
    }

    confirmPasswordEnable = () => {
        if (!this.root!.userAuth!.isSignedUp) return false

        const confirmPasswordEnable = this.GetPackageConfigByKey('Worklist.EnableConfirmPassword')
        if (confirmPasswordEnable === null) return false
        return confirmPasswordEnable as boolean
    }

    getConfirmPasswordDescription = () => {
        if (!this.root!.userAuth!.isSignedUp) return null

        const confirmPasswordTitle = this.GetPackageConfigByKey('Worklist.ConfirmPasswordTitle')
        const confirmPasswordDesc = this.GetPackageConfigByKey('Worklist.ConfirmPasswordDescription')
        if (!confirmPasswordDesc || !confirmPasswordTitle) return null

        return {
            title: `${confirmPasswordTitle}`,
            content: `${confirmPasswordDesc}`,
        }
    }

    checkOriginalPatientSearchEnable = () => {
        if (!this.root!.userAuth!.isSignedUp) return false

        const originPatientSearchEnable = this.GetPackageConfigByKey('Worklist.EnableOriginalPatientSearch')
        if (originPatientSearchEnable === null) return false
        return originPatientSearchEnable as boolean
    }

    getKLUCASStatInfo = () => {
        if (!this.root!.userAuth!.isSignedUp) return null

        const KLUCASStatToken = this.GetPackageConfigByKey('Dashboard.KLUCAS_Stat_Token') as string
        const KLUCASStatTitle = this.GetPackageConfigByKey('Dashboard.KLUCAS_Stat_Title') as string
        let KLUCASStatUrl = this.GetPackageConfigByKey('Dashboard.KLUCAS_Stat_URL') as string
        const isValidKLUCASStaUrl = KLUCASStatUrl && KLUCASStatUrl !== ''
        KLUCASStatUrl =
            isValidKLUCASStaUrl && KLUCASStatUrl[0] === '.'
                // eslint-disable-next-line
                ? `${location.origin}${KLUCASStatUrl.slice(1, KLUCASStatUrl.length)}`
                : KLUCASStatUrl

        return {
            url: KLUCASStatUrl,
            token: KLUCASStatToken,
            title: KLUCASStatTitle,
            groupKey: this.root!.product!.gatewayInfo
              ? this.root!.product!.gatewayInfo.assigned_group_key
              : undefined
        }
    }

    getKLUCASNoticeInfo = () => {
        if (!this.root!.userAuth!.isSignedUp) return null

        const token = this.root!.userAuth!.accessToken!
        const KLUCASNoticeTitle = this.GetPackageConfigByKey('Dashboard.KLUCAS_Notice_Title') as string
        let KLUCASNoticeUrl = this.GetPackageConfigByKey('Dashboard.KLUCAS_Notice_URL') as string
        const isValidKLUCASStaUrl = KLUCASNoticeUrl && KLUCASNoticeUrl !== ''
        KLUCASNoticeUrl =
            isValidKLUCASStaUrl && KLUCASNoticeUrl[0] === '.'
                // eslint-disable-next-line
                ? `${location.origin}${KLUCASNoticeUrl.slice(1, KLUCASNoticeUrl.length)}`
                : KLUCASNoticeUrl

        return {
            token,
            url: KLUCASNoticeUrl,
            title: KLUCASNoticeTitle,
            productKey: this.root!.product!.productKey,
        }
    }

    checkDryRunAPSEngineExecutionEnable = () => {
      if (!this.root!.userAuth!.isSignedUp) return false

      const dryRunAPSEngineExecutionEnable = this.GetPackageConfigByKey('Devel.EnableDryRunAPSEngineExecution')
      if (dryRunAPSEngineExecutionEnable === null) return false
      return dryRunAPSEngineExecutionEnable as boolean
  }
}
